module.exports = __webpack_public_path__ + "img/lainnya.88b80a3d.svg";